var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFacilitiesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_13979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7368 7.38789C14.7368 3.30717 11.4384 0 7.36842 0C3.29846 0 0 3.30717 0 7.38789C0 10.426 1.83372 13.0381 4.45012 14.1704L7.36842 20L10.2867 14.1704C12.9031 13.0381 14.7368 10.426 14.7368 7.38789Z",
    fill: "url(#paint0_linear_283_13979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 7.38775C10.8008 9.28237 9.26899 10.8295 7.36818 10.8295C5.46737 10.8295 3.93555 9.29358 3.93555 7.38775C3.93555 5.48192 5.46737 3.94604 7.36818 3.94604C9.26899 3.94604 10.8008 5.48192 10.8008 7.38775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_283_13979",
    x1: 5.3558,
    y1: 0.818386,
    x2: 10.3892,
    y2: 17.1114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB6365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9292C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_13979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7368,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFacilitiesIcon);
export default __webpack_public_path__ + "static/media/home-Facilities-icon.06c0ed8fbf4a1b0b5825699ddc2035d2.svg";
export { ForwardRef as ReactComponent };